import Data from "./Data.js";

export default class Dropdown
{
    constructor() {
        this.data = new Data();

        document.addEventListener('click', e => {
            const target = e.target;

            if (target.closest('.dropdown') && target.matches('.icon--remove')) {
                const searchInput = target.closest('.dropdown').querySelector('.dropdown__item--header input');
                searchInput.value = null;
                const curDD = target.closest('.dropdown');
                curDD.querySelectorAll('.dropdown__item').forEach(item => item.classList.remove('dropdown__item--hide'));
                curDD.querySelectorAll('.dropdown__section')?.forEach(item => item.removeAttribute('style'));
                curDD.querySelector('.no-match')?.remove();
            }

            // if user clicks on dropdown item
            if (target.closest('.dropdown') && target.closest('.dropdown__item:not(.dropdown__item--active)') && !target.closest('.dropdown__item.dropdown__item--header')) {
                const dropdown = target.closest('.dropdown');
                const dropdownItem = target.closest('.dropdown__item');
                const dropdownFieldValue = dropdown.querySelector('.dropdown__value input');

                if (!target.closest('.dropdown__item').querySelector('input[type="checkbox"]')) {

                    if (!dropdown.closest('.user')) {
                        const icon = dropdownItem.querySelector('.icon');

                        if (icon && dropdown.querySelector('.dropdown__selected .icon')) {
                            dropdown.querySelector('.dropdown__selected .icon').className = icon.className;
                        }

                        let selectedItemValue = dropdownItem.querySelector('span:' + (dropdownItem.querySelector('.dropdown__grouped') ? 'first' : 'last') + '-of-type').textContent;

                        if (dropdownItem.closest('.dropdown__section')) {
                            selectedItemValue += ' ' + dropdownItem.closest('.dropdown__section').querySelector('.section__title').textContent;
                        }

                        dropdown.querySelector('.dropdown__selected').dataset.value = dropdownItem.dataset.value;
                        dropdown.querySelector('.dropdown__selected span:last-of-type').textContent = selectedItemValue;

                        const ddInputValue = dropdown.querySelector('.dropdown__value input');
                        ddInputValue.setAttribute('value', dropdownItem.dataset.value);
                        ddInputValue.dispatchEvent(new Event('input', { bubbles: true }));
                        ddInputValue.dispatchEvent(new Event('change', { bubbles: true }));
                    }

                    const dropdownValue = dropdownItem.dataset.value ?? null;
                    dropdownFieldValue.value = dropdownItem.dataset.value;

                    this.runCallbacks(dropdown, dropdownItem, dropdownValue);
                } else {
                    let checkbox = dropdownItem.querySelector('input[type="checkbox"]');

                    if (target !== checkbox) {
                        dropdownItem.querySelector('input[type="checkbox"]').checked = !checkbox.checked;
                    }

                    dropdownItem.classList.toggle('dropdown__item--selected');
                    let values = [];
                    dropdown.querySelectorAll('input[type="checkbox"]:checked').forEach(item => values.push(item.closest('.dropdown__item').dataset.value));
                    dropdownFieldValue.value = values.join(',');
                }

                const event = new Event('input', { bubbles: true });
                dropdownFieldValue.dispatchEvent(event);
            }

            // if user clicks on dropdown
            if (target.closest('.dropdown')) {
                const dropdown = target.closest('.dropdown');

                if (!dropdown.classList.contains('dropdown--active')) {
                    const rect = dropdown.getBoundingClientRect();
                    const viewportHeight = window.innerHeight;
                    const maxHeight = dropdown.querySelector('.dropdown__content').offsetHeight;
                    const spaceBelow = viewportHeight - rect.bottom;
                    const spaceAbove = rect.top - document.querySelector('header').offsetHeight;

                    const shouldFlip = spaceBelow < maxHeight && spaceAbove > spaceBelow && spaceAbove > maxHeight;

                    if (shouldFlip) {
                        dropdown.classList.add('dropdown--flipped');
                    } else {
                        dropdown.classList.remove('dropdown--flipped');
                    }
                }

                const isSearchBar = target.closest('.dropdown__item.dropdown__item--header');
                const isKeepOpened = dropdown.classList.contains('dropdown--keep-opened');

                if (isSearchBar) {
                    return;
                }

                if (isKeepOpened && dropdown.classList.contains('dropdown--active') && target.closest('.dropdown__content')) {
                    return;
                }

                if (dropdown.classList.contains('dropdown--options')) {
                    dropdown.querySelector('.dropdown__selected .text').textContent = '';
                }

                if (target.closest('.feature-pages-categories-categories_builder') && !target.closest('.placeholder__header') && dropdown.classList.contains('dropdown--options')) {
                    this.showHideOptionsForBuilder(dropdown, target);
                }

                const dd = target.closest('.dropdown');
                this.closeThemAll(dd);

                if (!dropdown.classList.contains('dropdown--options')) {
                    // reset marked as default selected value and set the actual selected value
                    const ddSelected = dd.querySelector('.dropdown__selected');

                    dd.querySelectorAll('.dropdown__item:not(.dropdown__item--header)').forEach(item => {
                        if (item.dataset.value === ddSelected.dataset.value) {
                            item.classList.add('dropdown__item--active');
                        } else {
                            item.classList.remove('dropdown__item--active');
                        }
                    });
                }

                if (!target.closest('.dropdown__item')?.querySelector('input[type="checkbox"]')) {
                    dd.classList.toggle('dropdown--active');

                    if (dd.classList.contains('dropdown--header')) {
                        dd.querySelector('.dropdown__item--header input').value = null;
                        dd.querySelectorAll('.dropdown__item').forEach(item => item.classList.remove('dropdown__item--hide'));
                    }

                    const selectedItem = dd.querySelector('.dropdown__item--active');

                    if (selectedItem) {
                        setTimeout(() => {
                            selectedItem.scrollIntoView({
                                behavior: 'smooth',
                                block: 'nearest'
                            });
                        }, 300);
                    } else {
                        setTimeout(() => dd.querySelector('.dropdown__content').scrollTop = 0, 200);
                    }
                }
            }

            // if user clicks outside the dropdown it will close any active dropdowns
            if (!target.closest('.dropdown')) {
                this.closeThemAll();
            }
        });

        document.addEventListener('focus', e => {
            if (e.target.closest('.dropdown__searchbar') && e.target.matches('input')) {
                e.target.closest('.dropdown').classList.add('dropdown--searchbar-focused');
            }
        }, true);

        document.addEventListener('blur', e => {
            if (e.target.closest('.dropdown__searchbar') && e.target.matches('input')) {
                e.target.closest('.dropdown').classList.remove('dropdown--searchbar-focused');
            }
        }, true);

        document.addEventListener('input', e => {
           if (e.target.closest('.dropdown__searchbar')) {
               const closestDD = e.target.closest('.dropdown');
               closestDD.querySelectorAll('.dropdown__item:not(.dropdown__item--header)').forEach(item => {
                   const itemValue = item.textContent.trim().toLowerCase();
                   if (!itemValue.includes(e.target.value.trim().toLowerCase())) {
                       item.classList.add('dropdown__item--hide');
                   } else {
                       item.classList.remove('dropdown__item--hide');
                   }
               });

               closestDD.querySelectorAll('.dropdown__section').forEach(section => {
                   if (section.querySelectorAll('.dropdown__item:not(.dropdown__item--hide)').length) {
                       section.style.display = '';
                   } else {
                       section.style.display = 'none';
                   }
               });

               if (closestDD.querySelectorAll('.dropdown__item:not(.dropdown__item--header):not(.dropdown__item--hide)').length) {
                   closestDD.querySelector('.dropdown__content .no-match')?.remove();
               } else {
                   if (!closestDD.querySelector('.dropdown__content .no-match')) {
                       closestDD.querySelector('.dropdown__content').insertAdjacentHTML('beforeend', '<div class="no-match"><span class="milo milo--empty"></span>' + __('text_no_matches_found') + '</div>');
                   }
               }
           }
        });
    }

    runCallbacks(dropdown, dropdownItem, dropdownValue) {
        if (dropdown.closest('#spaces-switcher')) {
            this.data.switchSpace({space_id: dropdownValue}).then(response => {
                if (response.status === 'success' && !response.error) {
                    window.location.reload();
                    return;
                }
            });
        }

        if (/^\/[\/a-z0-9]+/.test(dropdownValue) && !/^\/[a-z]{2}\/$/.test(dropdownValue)) {
            window.location = dropdownValue;
            return;
        }

        if (!dropdownValue) {
            requestAnimationFrame(() => dropdown.classList.remove('dropdown--active'));
            return;
        }
    }

    showHideOptionsForBuilder(dropdown, target)
    {
        dropdown.querySelectorAll('.dropdown__item').forEach(item => item.classList.remove('dropdown__item--inactive'));

        const placeholderRow = target.closest('.placeholder__row');
        const parentId = placeholderRow.dataset.parentId;
        const depth = placeholderRow.dataset.depth;

        const siblings = Array.from(
            placeholderRow.parentNode.querySelectorAll(`[data-parent-id="${parentId}"][data-depth="${depth}"]`)
        ).sort((a, b) => Number(a.dataset.position) - Number(b.dataset.position));

        const currentIndex = siblings.indexOf(placeholderRow);

        if (currentIndex <= 0) {
            dropdown.querySelector('.move-up')?.classList.add('dropdown__item--inactive');
            dropdown.querySelector('.move-to-top')?.classList.add('dropdown__item--inactive');
        }

        if (currentIndex === -1 || currentIndex === siblings.length - 1) {
            dropdown.querySelector('.move-down')?.classList.add('dropdown__item--inactive');
            dropdown.querySelector('.move-to-bottom')?.classList.add('dropdown__item--inactive');
        }

        if (Number(placeholderRow.dataset.transactions) > 0) {
            dropdown.querySelector('.dropdown__item.delete').classList.add('dropdown__item--hide');
        } else {
            if (!placeholderRow.classList.contains('placeholder__row--container')) {
                dropdown.querySelector('.dropdown__item.delete').classList.remove('dropdown__item--hide');
                dropdown.querySelector('.dropdown__item.archive').classList.add('dropdown__item--hide');
            } else {
                if (!placeholderRow.parentNode.querySelectorAll('[data-parent-id="' + placeholderRow.dataset.id + '"]').length) {
                    dropdown.querySelector('.dropdown__item.delete').classList.remove('dropdown__item--hide');
                } else {
                    dropdown.querySelector('.dropdown__item.delete').classList.add('dropdown__item--hide');
                }
                dropdown.querySelector('.dropdown__item.archive').classList.add('dropdown__item--hide');
            }
        }
    }

    closeThemAll(current) {
        document.querySelectorAll('.dropdown--active').forEach(dropdown => {
            if (current !== dropdown) {
                dropdown.classList.remove('dropdown--active', 'dropdown--prevent-auto-scroll-closing');

                setTimeout(() => {
                    if (dropdown.classList.contains('dropdown--searchbar')) {
                        dropdown.querySelector('.dropdown__searchbar input').value = null;
                        dropdown.querySelectorAll('.dropdown__item').forEach(item => item.classList.remove('dropdown__item--hide'));
                        dropdown.querySelectorAll('.dropdown__section')?.forEach(item => item.removeAttribute('style'));
                        dropdown.querySelector('.no-match')?.remove();
                    }

                    dropdown.querySelector('.dropdown__content').scrollTop = 0
                }, 200);
            }
        });
    }
}